import { LoadableLazy } from '@confluence/loadable';

export const EditPageLoadingListener = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EditPageLoadingListener" */ '../src/EditPageLoadingListener.tsx'
			)
		).EditPageLoadingListener,
});
